<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
						<!--기준일-->
					<sf-group-wrapper :label="getMessage_('QWCC001170')">
						<el-date-picker :value="searchParams.stdDt" @input="changeSearchDate" format="yyyy-MM-dd" value-format="yyyyMMdd" />
					</sf-group-wrapper>
				</el-col>
				<el-col :span="3">
						<!--품번-->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:propData="searchParams.partNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
						<!--협력사-->
					<search-input :label="getMessage_('QWCC000958')" paramKey="cpnyCd" @commInput="setSearchParam" :propData="searchParams.cpnyCd" />
				</el-col>
				<el-col :span="3">
						<!--실납품사-->
					<search-input :label="getMessage_('QWCC001924')" paramKey="dlvgNm" @commInput="setSearchParam" :propData="searchParams.dlvgNm" />
				</el-col>
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000059')"
						paramKey="partG"
						:options="partGList"
						:propData="searchParams.partG"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<!--초기화-->
				<!-- <sf-button line :onClick="() => searchInit()" v-if="isButton_(scrId, 'CR')" class="icon-sf-refresh">
					{{ getMessage_('QWCC001109') }}
				</sf-button> -->
				<!--조회-->
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({});
		}
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		changeSearchDate(value) {
			this.setSearchParam_({ key: 'stdDt', value });
		},
		//조회 이벤트
		searchList() {
			const searchParams = this.searchParams;
			//벨리데이션 체크
			try {
				this.insVali.validateSync(searchParams);
			} catch (error) {
				const today = this.$moment().format('YYYY-MM-DD'); //오늘날짜
				this.changeSearchDate(today);
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				return error;
			}
			this.$sf_toggleLoading(true);
			this.getPartCost_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			this.setStateClear_(); //조회시 MasterTable영역 초기화
		}

		// searchInit() {
		// 	this.setSearchInit_();
		// }
	},
	async created() {
		try {
			this.searchAplcDdDt = [this.getStartAplcDd_, this.getEndAplcDd_];
			this.searchDcsnDdDt = [this.getStartDcsnDd_, this.getEndDcsnDd_];
			this.searchDate = this.$moment(this.stdDt_).format('YYYY-MM-DD'); //오늘날짜
			await this.getCommCodes_({ key: 'partGList', codeType: 'PART_G' });

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
